var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "monitor-datatable", attrs: { id: "monitor-datatable" } },
    [
      _vm.table_data_structure.length
        ? [
            _vm.show_copyright_logo
              ? _c("div", { staticClass: "capture" }, [
                  _c(
                    "div",
                    { staticClass: "capture__text-container" },
                    [
                      _c("v-progress-circular", {
                        staticClass: "capture__progress",
                        attrs: {
                          indeterminate: "",
                          size: "18",
                          width: "2",
                          color: "black"
                        }
                      }),
                      _vm._v(
                        "\n                     " +
                          _vm._s(_vm.$t("__datatable.capture_text")) +
                          "\n            "
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.table_data_structure, function(ref, index) {
              var headers = ref.headers
              var data = ref.data
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "table__content",
                  style: _vm.css_props
                },
                [
                  _c("v-data-table", {
                    staticClass: "bg-opacity-white elevation-1",
                    attrs: {
                      headers: headers,
                      "hide-default-header":
                        !_vm.show_header || _vm.custom_header,
                      "header-props": {
                        "sort-icon": "icon-triangle"
                      },
                      items: data,
                      search: _vm.search,
                      "no-data-text": _vm.$t("__datatable.no_data_text"),
                      "no-results-text": _vm.$t("__datatable.no_results_text"),
                      "items-per-page": _vm.items_per_page,
                      "hide-default-footer": _vm.show_copyright_logo,
                      "custom-sort": _vm.custom_sort,
                      "mobile-breakpoint": 0,
                      "footer-props": _vm.footer_props
                    },
                    on: {
                      "update:itemsPerPage": function($event) {
                        _vm.items_per_page = $event
                      },
                      "update:items-per-page": function($event) {
                        _vm.items_per_page = $event
                      },
                      "current-items": function($event) {
                        return _vm.change_width()
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "footer.page-text",
                          fn: function(props) {
                            return [
                              _vm.items_per_page < 0
                                ? [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s("1 / 1") +
                                        "    \n                    "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          Math.ceil(
                                            props.pageStop / _vm.items_per_page
                                          )
                                        ) +
                                        " / " +
                                        _vm._s(
                                          Math.ceil(
                                            props.itemsLength /
                                              _vm.items_per_page
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                            ]
                          }
                        },
                        _vm.custom_header
                          ? {
                              key: "header",
                              fn: function(ref) {
                                var headers = ref.props.headers
                                return [
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      [
                                        _vm._l(headers, function(header, key) {
                                          return [
                                            !header.second_text &&
                                            !header.third_text
                                              ? _c(
                                                  "th",
                                                  {
                                                    key: key + "_th1",
                                                    staticClass:
                                                      "text_align_center",
                                                    attrs: { rowspan: "3" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(header.text) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : header.text
                                                ? _c(
                                                    "th",
                                                    {
                                                      key: key + "_th1",
                                                      staticClass:
                                                        "text_align_center",
                                                      attrs: {
                                                        colspan: headers.filter(
                                                          function(header) {
                                                            return (
                                                              header.second_text ||
                                                              header.third_text
                                                            )
                                                          }
                                                        ).length
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(header.text) +
                                                          "\n                                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      [
                                        _vm._l(headers, function(header, key) {
                                          return [
                                            header.second_text
                                              ? _c(
                                                  "th",
                                                  {
                                                    key: key + "_th2",
                                                    staticClass:
                                                      "text_align_center",
                                                    attrs: {
                                                      colspan:
                                                        headers.filter(function(
                                                          header
                                                        ) {
                                                          return header.third_text
                                                        }).length /
                                                        headers.filter(function(
                                                          header
                                                        ) {
                                                          return header.second_text
                                                        }).length
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          header.second_text
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      [
                                        _vm._l(headers, function(header, key) {
                                          return [
                                            header.third_text
                                              ? _c(
                                                  "th",
                                                  {
                                                    key: key + "_th3",
                                                    staticClass:
                                                      "text_align_center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          header.third_text
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              }
                            }
                          : null,
                        _vm.error_text
                          ? {
                              key: "body",
                              fn: function(ref) {
                                var headers = ref.headers
                                return [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        { attrs: { colspan: headers.length } },
                                        [
                                          _c(
                                            "v-alert",
                                            {
                                              style: { height: 50 + "px" },
                                              attrs: {
                                                value: true,
                                                type: "error"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(_vm.error_text) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                ]
                              }
                            }
                          : {
                              key: "item",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "tr",
                                    {
                                      class: [
                                        {
                                          "tr--focal":
                                            (item["項次"] || item["編號"]) ===
                                            _vm.focal_sign_number
                                        },
                                        _vm.table_label_function(item)
                                      ],
                                      attrs: {
                                        id:
                                          "row_" +
                                          (item["項次"] ||
                                            item["編號"] ||
                                            "unavailable")
                                      }
                                    },
                                    _vm._l(headers, function(value, key) {
                                      return _c(
                                        "td",
                                        {
                                          key: key,
                                          class: [
                                            {
                                              border_right:
                                                _vm.show_table_border,
                                              "td--focal":
                                                (item["項次"] ||
                                                  item["編號"]) ===
                                                _vm.focal_sign_number,
                                              text_align_center: _vm.is_style_align_center(
                                                item[value.value],
                                                value.value
                                              )
                                            },
                                            (item["項次"] || item["編號"]) ===
                                              _vm.focal_sign_number &&
                                              _vm.get_signal_focal_class(
                                                item,
                                                value
                                              )
                                          ]
                                        },
                                        [
                                          _vm.should_draw_diagram_header.includes(
                                            value.value
                                          ) &&
                                          _vm.should_display_info_header.includes(
                                            value.value
                                          ) &&
                                          _vm.generate_tooltop_display_info(
                                            item,
                                            value.value
                                          )
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { right: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "span",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "links tooltip__box",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.show_dialog(
                                                                        value.value,
                                                                        item[
                                                                          value
                                                                            .value
                                                                        ],
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  "\n                                        " +
                                                                    _vm._s(
                                                                      item[
                                                                        value
                                                                          .value
                                                                      ]
                                                                    ) +
                                                                    "\n                                    "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.generate_tooltop_display_info(
                                                          item,
                                                          value.value
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm.should_draw_diagram_header.includes(
                                                value.value
                                              ) && _vm.name != 8
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "links",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.show_dialog(
                                                          value.value,
                                                          item[value.value],
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          item[value.value]
                                                        ) +
                                                        "\n                            "
                                                    )
                                                  ]
                                                )
                                              : _vm.should_display_info_header.includes(
                                                  value.value
                                                ) &&
                                                _vm.generate_tooltop_display_info(
                                                  item,
                                                  value.value
                                                )
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { right: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "span",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "tooltip__box",
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          item[
                                                                            value
                                                                              .value
                                                                          ]
                                                                        )
                                                                      }
                                                                    },
                                                                    on
                                                                  )
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.generate_tooltop_display_info(
                                                              item,
                                                              value.value
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm.should_show_raw_html_header.includes(
                                                    value.value
                                                  )
                                                  ? [
                                                      _vm._l(
                                                        item[value.value],
                                                        function(
                                                          icon,
                                                          icon_key
                                                        ) {
                                                          return [
                                                            icon.tooltip_content
                                                              ? _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    key: icon_key,
                                                                    attrs: {
                                                                      right: ""
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "activator",
                                                                          fn: function(
                                                                            ref
                                                                          ) {
                                                                            var on =
                                                                              ref.on
                                                                            return [
                                                                              _c(
                                                                                "span",
                                                                                _vm._g(
                                                                                  {
                                                                                    staticClass:
                                                                                      "tooltip__box",
                                                                                    class: {
                                                                                      "table__alert--map-active":
                                                                                        _vm.is_monitor_open_emap
                                                                                    },
                                                                                    domProps: {
                                                                                      innerHTML: _vm._s(
                                                                                        icon.html
                                                                                      )
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.focus_on_sign(
                                                                                          item,
                                                                                          value
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  on
                                                                                )
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  },
                                                                  [
                                                                    _vm._v(" "),
                                                                    _c("span", {
                                                                      domProps: {
                                                                        innerHTML: _vm._s(
                                                                          icon.tooltip_content
                                                                        )
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              : _c("span", {
                                                                  key: icon_key,
                                                                  class: {
                                                                    "table__alert--map-active":
                                                                      _vm.is_monitor_open_emap,
                                                                    "raw-html--center":
                                                                      icon.center
                                                                  },
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      icon.html
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.focus_on_sign(
                                                                        item,
                                                                        value
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                          ]
                                                        }
                                                      )
                                                    ]
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            item[value.value]
                                                          ) +
                                                          "\n                            "
                                                      )
                                                    ])
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ]
                              }
                            }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show_copyright_logo,
                          expression: "show_copyright_logo"
                        }
                      ],
                      staticClass: "copyright"
                    },
                    [
                      _c("img", {
                        staticClass: "copyright__img",
                        attrs: {
                          src:
                            "/static/images/capture/blue_cwa_logo_string_eng.png"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "diagram-dialog",
                      style: _vm.css_dialog_props
                    },
                    [
                      _vm._t("diagram_dialog", null, {
                        close_dialog: _vm.close_dialog
                      })
                    ],
                    2
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table__btn-container" },
              [
                _vm.show_description_dialog_btn
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "table__btn",
                        attrs: { fab: "", "x-small": "" },
                        on: { click: _vm.open_description_dialog }
                      },
                      [
                        _c("v-icon", [_vm._v("icon-help")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "table__btn-text" }, [
                          _vm._v(_vm._s(_vm.$t("__datatable.hint")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show_download_doc_btn
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "table__btn",
                        attrs: { fab: "", "x-small": "" },
                        on: { click: _vm.call_monitor_document_ajax }
                      },
                      [
                        _c("v-icon", [_vm._v("icon-doc-text")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "table__btn-text" }, [
                          _vm._v("附錄文件")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show_download_pdf_btn
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "table__btn",
                        attrs: { fab: "", "x-small": "" },
                        on: { click: _vm.download_as_pdf }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#2366f8" } }, [
                          _vm._v(
                            "\n                    icon-file-download\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "table__btn-text" }, [
                          _vm._v("下載表格")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.show_download_png_btn
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "table__btn",
                        attrs: { fab: "", "x-small": "" },
                        on: { click: _vm.download_as_png }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#2366f8" } }, [
                          _vm._v(
                            "\n                    icon-file-download\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "table__btn-text" }, [
                          _vm._v("下載圖片")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-dialog",
              {
                attrs: { height: "100%", "content-class": "table-dialog" },
                model: {
                  value: _vm.description_dialog,
                  callback: function($$v) {
                    _vm.description_dialog = $$v
                  },
                  expression: "description_dialog"
                }
              },
              [
                _c("div", { staticClass: "table-description" }, [
                  _c(
                    "div",
                    { staticClass: "table-description__header" },
                    [
                      _c("v-icon", { attrs: { color: "#ffffff" } }, [
                        _vm._v(
                          "\n                        icon-help\n                    "
                        )
                      ]),
                      _vm._v(
                        "\n                    說明\n                    "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "table-description__close-btn",
                          attrs: { color: "#ffffff", icon: "" },
                          on: {
                            click: function($event) {
                              _vm.description_dialog = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("icon-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-description__content" },
                    [
                      _vm._t("table_description", function() {
                        return [
                          _c("div", [
                            _c(
                              "span",
                              [
                                _vm._v("預警: "),
                                _c(
                                  "v-icon",
                                  { staticClass: "signal--warning" },
                                  [_vm._v("icon-pentagon")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _vm._v("警戒: "),
                                _c("v-icon", { staticClass: "signal--alert" }, [
                                  _vm._v("icon-square")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _vm._v("行動: "),
                                _c(
                                  "v-icon",
                                  { staticClass: "signal--action" },
                                  [_vm._v("icon-triangle")]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v("\n                            說明:"),
                            _c("br"),
                            _vm._v(
                              "\n                            1. 「--」 表示該欄位無資料。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            2.雨量資料問題請撥打(02)2349-7972。"
                            ),
                            _c("br")
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ])
              ]
            )
          ]
        : _vm.error_text
          ? _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    staticClass: "alert",
                    attrs: { value: true, type: "info" }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.error_text) + "\n        "
                    )
                  ]
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "v-alert",
                  {
                    staticClass: "info color_white",
                    attrs: { value: true, color: "#3366a9" }
                  },
                  [
                    _c("v-progress-circular", {
                      staticClass: "color_white",
                      attrs: { indeterminate: "", color: "black" }
                    }),
                    _vm._v(
                      "\n                 " +
                        _vm._s(_vm.$t("__datatable.loading_text")) +
                        "\n        "
                    )
                  ],
                  1
                )
              ],
              1
            )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }